import React, { useEffect, useState } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Button,
  Select,
  MenuItem,
  Stack,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Tooltip,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "../api/Constant";
import html2pdf from "html2pdf.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";

/* ---------- TRANSLATIONS ---------- */
const translations = {
  en: {
    back: "← Back",
    downloadPdf: "Download PDF",
    title: "Amrit Sarovar Form",
    langToggle: "हिन्दी",
    freezeNotice: "This form has been edited 1 time and is now completely frozen. Changes cannot be made again.",
    colSrNo: "Sr. No.",
    col1: "Are Amrit Sarovars constructed in this Gram Panchayat under the Amrit Sarovar Scheme? (Yes/No) *",
    col2: "If yes, what is the condition of the Amrit Sarovar? (Good/Bad) *",
    col3: "If condition of Amrit Sarovar is good, for what purpose is water being used? *",
    col4: "Sanctioned/Released Amount for Amrit Sarovar *",
    col5: "Utilized Funds for Amrit Sarovar *",
    col6: "Work Status of Amrit Sarovar (Completed/In Progress/Not Started) *",
    col7: "Gram Sabha Members Remarks *",
    colAction: "Action",
    yes: "Yes",
    no: "No",
    select: "Select",
    good: "Good",
    bad: "Bad",
    completed: "Completed",
    inProgress: "In Progress",
    notStarted: "Not Started",
    placeholderUsage: "Enter water usage purpose",
    placeholderAmount: "0",
    placeholderRemarks: "Enter remarks",
    edit: "Edit",
    frozen: "Frozen",
    frozenTooltip: "This record has been updated 1 time and is now completely frozen",
    delete: "Delete",
    submit: "Submit",
    update: "Update",
    cancel: "Cancel",
    confirmSaveTitle: "Save Changes",
    confirmUpdateTitle: "Confirm Update",
    confirmSaveMsg: "After saving you will be allowed to edit only once. Do you want to proceed?",
    confirmUpdateMsg: "After saving this time, you will not be allowed to edit this form again. Do you want to proceed?",
    yesSave: "Yes, Save",
    yesUpdate: "Yes, Update",
    errSelectCondition: "Please select Amrit Sarovar condition",
    errUsagePurpose: "Please enter water usage purpose",
    errApprovedAmount: "Please enter approved amount",
    errUsedAmount: "Please enter utilized amount",
    errWorkStatus: "Please select work status",
    errRemarks: "Please enter Gram Sabha remarks",
    frozenAlertTitle: "Form Frozen",
    frozenAlertMsg: "This record has been updated 1 time and is now completely frozen. It cannot be edited again.",
    deleteConfirmTitle: "Do you want to delete data?",
    deleteConfirmMsg: "This action cannot be undone",
    yesDelete: "Yes, Delete",
    savedSuccessfully: "Saved successfully!",
    savedSuccessMsg: "After saving you will be allowed to edit only once.",
    updatedSuccessfully: "Form fully frozen!",
    updatedSuccessMsg: "After saving this time, you will not be allowed to edit this form again.",
    okay: "Okay",
    submitFailed: "Submit failed",
    noRecordFound: "Record not available",
  },
  hi: {
    back: "← वापस जाएँ",
    downloadPdf: "PDF डाउनलोड करें",
    title: "अमृत सरोवर प्रपत्र",
    langToggle: "English",
    freezeNotice: "यह फॉर्म 1 बार संपादित हो चुका है और अब पूरी तरह से फ्रिज्ड (Freeze) है। इसमें दोबारा बदलाव नहीं किए जा सकते।",
    colSrNo: "क्र. सं.",
    col1: "क्या इस ग्राम पंचायत में अमृत सरोवर योजना के तहत अमृत सरोवर बनाए गए हैं? (हां/ नहीं) *",
    col2: "यदि हां, तो अमृत सरोवर की स्थिति क्या है? (अच्छा/बुरा) *",
    col3: "अगर अमृत सरोवर की स्थिति अच्छी है तो इस सरोवर के पानी का उपयोग किस उद्देश्य के लिए किया जा रहा है *",
    col4: "अमृत सरोवर के लिए धनराशि स्वीकृत/जारी की गई *",
    col5: "अमृत सरोवर के लिए उपयोग की गई निधि *",
    col6: "अमृत सरोवर के कार्य की स्थिति (पूर्ण/प्रगति/शुरू नहीं) *",
    col7: "ग्राम सभा के सदस्यों की टिप्पणियां *",
    colAction: "कार्यवाही",
    yes: "हाँ",
    no: "नहीं",
    select: "चुनें",
    good: "अच्छी",
    bad: "बुरी",
    completed: "पूर्ण",
    inProgress: "प्रगति",
    notStarted: "शुरू नहीं",
    placeholderUsage: "उपयोग का उद्देश्य दर्ज करें",
    placeholderAmount: "0",
    placeholderRemarks: "टिप्पणी दर्ज करें",
    edit: "संपादन",
    frozen: "फ्रिज्ड (Freeze)",
    frozenTooltip: "यह रिकॉर्ड 1 बार अपडेट किया जा चुका है और अब पूरी तरह से फ्रिज्ड (Freeze) है",
    delete: "हटाएँ",
    submit: "जमा करें",
    update: "अपडेट करें",
    cancel: "रद्द करें",
    confirmSaveTitle: "बदलाव सहेजें",
    confirmUpdateTitle: "अपडेट की पुष्टि करें",
    confirmSaveMsg: "सहेजने के बाद आपको केवल एक बार एडिट करने की अनुमति होगी। क्या आप आगे बढ़ना चाहते हैं?",
    confirmUpdateMsg: "इस बार सहेजने के बाद आपको इस फॉर्म को दोबारा एडिट करने की अनुमति नहीं होगी। क्या आप आगे बढ़ना चाहते हैं?",
    yesSave: "हाँ, सहेजें",
    yesUpdate: "हाँ, अपडेट करें",
    errSelectCondition: "कृपया अमृत सरोवर की स्थिति चुनें",
    errUsagePurpose: "कृपया पानी के उपयोग का उद्देश्य दर्ज करें",
    errApprovedAmount: "कृपया स्वीकृत धनराशि दर्ज करें",
    errUsedAmount: "कृपया उपयोग की गई निधि दर्ज करें",
    errWorkStatus: "कृपया कार्य की स्थिति चुनें",
    errRemarks: "कृपया ग्राम सभा की टिप्पणियां दर्ज करें",
    frozenAlertTitle: "फॉर्म फ्रिज है (Form Frozen)",
    frozenAlertMsg: "यह रिकॉर्ड 1 बार अपडेट किया जा चुका है और अब पूरी तरह से फ्रिज्ड (Freeze) है। इसे दोबारा एडिट नहीं किया जा सकता।",
    deleteConfirmTitle: "क्या आप डेटा हटाना चाहते हैं?",
    deleteConfirmMsg: "यह क्रिया पूर्ववत नहीं की जा सकती",
    yesDelete: "हाँ, बताएं",
    savedSuccessfully: "सफलतापूर्वक सहेजा गया!",
    savedSuccessMsg: "सहेजने के बाद आपको केवल एक बार एडिट करने की अनुमति होगी।",
    updatedSuccessfully: "फॉर्म पूरी तरह फ्रिज (Freeze) हो गया!",
    updatedSuccessMsg: "इस बार सहेजने के बाद आपको इस फॉर्म को दोबारा एडिट करने की अनुमति नहीं होगी।",
    okay: "ठीक है",
    submitFailed: "सबमिट विफल",
    noRecordFound: "रिकॉर्ड उपलब्ध नहीं है",
  }
};

/* ---------- DEFAULT DATA ---------- */
const emptyRow = {
  hasAmritSarovar: "1", // Default to "हाँ" which is "1"
  condition: "",
  waterUsage: "",
  approvedAmount: "",
  usedAmount: "",
  workStatus: "",
  remarks: "",
};

const AmritSarovar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [lang, setLang] = useState("en"); // Default English
  const [row, setRow] = useState({ ...emptyRow });
  const [isSubmittedState, setIsSubmitted] = useState(false);
  const isViewOnlyRole = ["1", "3", "7", "8"].includes(sessionStorage.getItem("role_id"));
  const isSubmitted = isSubmittedState || isViewOnlyRole;
  const [recordId, setRecordId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [allRecords, setAllRecords] = useState([]);
  const [hasRecords, setHasRecords] = useState(false);
  const [editedRecordsMap, setEditedRecordsMap] = useState({});
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [confirmType, setConfirmType] = useState("save"); // "save" or "update"

  const [fetchedDistrictCode, setFetchedDistrictCode] = useState("");
  const [fetchedBlockCode, setFetchedBlockCode] = useState("");

  const token = sessionStorage.getItem("token");
  const userId = sessionStorage.getItem("user_id");

  // Get meeting data from navigation state or sessionStorage
  const getMeetingData = () => {
    const fromState = location.state;
    if (fromState) return fromState;

    const fromStorage = sessionStorage.getItem("current_meeting");
    return fromStorage ? JSON.parse(fromStorage) : {};
  };

  const meetingData = getMeetingData();

  // Extract meeting data with fallbacks
  const district_code =
    meetingData.district_code ||
    meetingData.district_id ||
    meetingData.district ||
    meetingData.dist_code ||
    fetchedDistrictCode ||
    sessionStorage.getItem("district_code") ||
    "";

  const block_code =
    meetingData.block_code ||
    meetingData.block_id ||
    meetingData.block ||
    meetingData.blk_code ||
    fetchedBlockCode ||
    sessionStorage.getItem("block_code") ||
    "";

  const panchayat_code =
    meetingData.gram_panchayat_code ||
    meetingData.panchayat_code ||
    meetingData.gram_panchayat_id ||
    meetingData.panchayat_id ||
    sessionStorage.getItem("gram_panchayat_code") ||
    "";

  const sched_meet_id =
    meetingData.meeting_id ||
    meetingData.sched_meet_id ||
    meetingData.id ||
    "";

  const panchayat_name = meetingData.panchayat_name || "";

  /* ---------- PREFILL FROM DB (if exists) ---------- */
  useEffect(() => {
    if (!panchayat_code) {
      toast.error("Please select a Gram Sabha meeting first");
      navigate("/gram-sabha-mom");
      return;
    }

    fetchSarovar();
  }, []);

  useEffect(() => {
    const role = sessionStorage.getItem("role_id");
    if (["1", "3", "7", "8"].includes(role)) {
      // Force all records to be frozen by faking it in the UI when they render,
      // or by simply setting a global isFrozen state if it existed.
      // Wait, AmritSarovar might use per-record freezing or a global editedRecordsMap.
      // We will need to check how it freezes.
    }
  }, []);

  const fetchSarovar = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/get_all_sarovar_details", {
        params: {
          page: 1,
          limit: 10000,
          panchayat_code: panchayat_code,
          sched_meet_id: sched_meet_id,
          meeting_id: sched_meet_id,
        },
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data?.status === "success") {
        let records = res.data.data || [];

        if (sched_meet_id) {
          const filtered = records.filter(
            (r) =>
              (r.sched_meet_id && String(r.sched_meet_id) === String(sched_meet_id)) ||
              (r.meeting_id && String(r.meeting_id) === String(sched_meet_id))
          );
          if (filtered.length > 0) {
            records = filtered;
          } else if (records.some((r) => r.sched_meet_id || r.meeting_id)) {
            records = [];
          }
        }

        const hasRecord = records.length > 0;

        setAllRecords(records);
        setHasRecords(hasRecord);

        // Update edit/freeze map for all records
        const editMap = {};
        records.forEach((r) => {
          if (
            r.is_edited === 1 ||
            r.is_edited === true ||
            r.is_edited === "1" ||
            r.is_freeze === 1 ||
            r.is_freeze === true ||
            r.is_freeze === "1" ||
            localStorage.getItem(`sarovar_edited_${r.id}`) === "true" ||
            localStorage.getItem(`sarovar_frozen_${r.id}`) === "true"
          ) {
            editMap[r.id] = true;
          }
        });
        setEditedRecordsMap(editMap);

        if (records.length > 0) {
          const d = records[0];
          if (d.district_code) setFetchedDistrictCode(d.district_code);
          if (d.block_code) setFetchedBlockCode(d.block_code);

          setRow({
            hasAmritSarovar: d.has_amrit_sarovar === 1 ? "1" : "0",
            condition: d.sarovar_condition === 1 ? "1" : d.sarovar_condition === 0 ? "0" : "",
            waterUsage: d.water_usage_purpose || "",
            approvedAmount: d.sanctioned_amount || "",
            usedAmount: d.utilized_amount || "",
            workStatus: d.work_status || "",
            remarks: d.gram_sabha_remarks || "",
          });

          setRecordId(d.id);
          setIsSubmitted(true);
        } else {
          setRow({ ...emptyRow });
          setIsSubmitted(false);
          setRecordId(null);
        }
      } else {
        setAllRecords([]);
        setHasRecords(false);
        setRow({ ...emptyRow });
        setIsSubmitted(false);
        setRecordId(null);
      }
    } catch (err) {
      console.error("Fetch Sarovar Error:", err);
      setAllRecords([]);
      setHasRecords(false);
    } finally {
      setLoading(false);
    }
  };

  /* ---------- HANDLE CHANGE ---------- */
  const handleChange = (field, value) => {
    if (isSubmitted) return;

    const updated = { ...row, [field]: value };

    if (field === "hasAmritSarovar" && value === "0") {
      updated.condition = "";
      updated.waterUsage = "";
      updated.approvedAmount = "";
      updated.usedAmount = "";
      updated.workStatus = "";
      updated.remarks = "";
    }

    setRow(updated);
  };
  const validateSarovarForm = () => {
    if (row.hasAmritSarovar === "1") {
      if (!row.condition || row.condition === "") {
        toast.error(translations[lang].errSelectCondition);
        return false;
      }
      if (row.condition === "1" && (!row.waterUsage || row.waterUsage.trim() === "")) {
        toast.error(translations[lang].errUsagePurpose);
        return false;
      }
      if (!row.approvedAmount || row.approvedAmount === "" || row.approvedAmount === "0") {
        toast.error(translations[lang].errApprovedAmount);
        return false;
      }
      if (!row.usedAmount || row.usedAmount === "") {
        toast.error(translations[lang].errUsedAmount);
        return false;
      }
      if (!row.workStatus || row.workStatus === "") {
        toast.error(translations[lang].errWorkStatus);
        return false;
      }
      if (!row.remarks || row.remarks.trim() === "") {
        toast.error(translations[lang].errRemarks);
        return false;
      }
    } else {
      if (!row.remarks || row.remarks.trim() === "") {
        toast.error(translations[lang].errRemarks);
        return false;
      }
    }
    return true;
  };

  /* ---------- DIALOG TRIGGERS ---------- */
  const handleSaveClick = () => {
    if (!validateSarovarForm()) return;
    setConfirmType("save");
    setOpenConfirmDialog(true);
  };

  const handleUpdateClick = () => {
    if (recordId && editedRecordsMap[recordId]) {
      Swal.fire({
        icon: "warning",
        title: translations[lang].frozenAlertTitle,
        text: translations[lang].frozenAlertMsg,
        confirmButtonText: translations[lang].okay,
      });
      return;
    }
    if (!validateSarovarForm()) return;
    setConfirmType("update");
    setOpenConfirmDialog(true);
  };

  /* ---------- EXECUTE CREATE ---------- */
  const executeSave = async () => {
    setOpenConfirmDialog(false);
    try {
      const payload = {
        district_code: district_code,
        block_code: block_code,
        panchayat_code: panchayat_code,
        gram_panchayat_code: panchayat_code,
        sched_meet_id: sched_meet_id,
        meeting_id: sched_meet_id,
        has_amrit_sarovar: row.hasAmritSarovar,
        sarovar_condition: row.condition || "",
        water_usage_purpose: row.waterUsage || "",
        sanctioned_amount: row.approvedAmount || "0",
        utilized_amount: row.usedAmount || "0",
        work_status: row.workStatus || "",
        gram_sabha_remarks: row.remarks || "",
        userId: userId,
        created_by: parseInt(userId || 0),
      };

      await axios.post("/create_sarovar_details", payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      Swal.fire({
        icon: "success",
        title: translations[lang].savedSuccessfully,
        text: translations[lang].savedSuccessMsg,
        confirmButtonText: translations[lang].okay || "Okay",
      });

      setIsSubmitted(true);
      await fetchSarovar();
    } catch (err) {
      console.error("Create Error:", err);
      toast.error("Save failed: " + (err.response?.data?.message || err.message));
    }
  };

  /* ---------- EXECUTE UPDATE (1st Edit -> Permanent Freeze) ---------- */
  const executeUpdate = async () => {
    setOpenConfirmDialog(false);
    if (!recordId) {
      toast.error("No record to update");
      return;
    }

    try {
      const normalizeToNull = (value) => {
        if (!value || value === "" || value.trim() === "" || value.trim() === "नहीं") {
          return null;
        }
        return value.trim();
      };

      const payload = {
        id: parseInt(recordId),
        district_code: district_code,
        block_code: block_code,
        panchayat_code: panchayat_code,
        gram_panchayat_code: panchayat_code,
        sched_meet_id: sched_meet_id,
        meeting_id: sched_meet_id,
        has_amrit_sarovar: parseInt(row.hasAmritSarovar),
        sarovar_condition: row.condition && row.condition !== "" ? parseInt(row.condition) : null,
        water_usage_purpose: normalizeToNull(row.waterUsage),
        sanctioned_amount: row.approvedAmount && row.approvedAmount !== "" ? parseFloat(row.approvedAmount) : null,
        utilized_amount: row.usedAmount && row.usedAmount !== "" ? parseFloat(row.usedAmount) : null,
        work_status: normalizeToNull(row.workStatus),
        gram_sabha_remarks: normalizeToNull(row.remarks),
        userId: userId,
        updated_by: parseInt(userId || 0),
        is_edited: 1,
        is_freeze: 1,
      };

      await axios.patch("/update_sarovar_details", payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (recordId) {
        localStorage.setItem(`sarovar_edited_${recordId}`, "true");
        localStorage.setItem(`sarovar_frozen_${recordId}`, "true");
        setEditedRecordsMap((prev) => ({ ...prev, [recordId]: true }));
      }

      Swal.fire({
        icon: "success",
        title: translations[lang].updatedSuccessfully,
        text: translations[lang].updatedSuccessMsg,
        confirmButtonText: translations[lang].okay || "Okay",
      });

      setIsSubmitted(true);
      await fetchSarovar();
    } catch (err) {
      console.error("Update Error:", err);
      toast.error("Update failed: " + (err.response?.data?.message || err.message));
    }
  };

  /* ---------- EDIT ---------- */
  const handleEdit = (recordIdToEdit) => {
    const targetId = recordIdToEdit || recordId;
    if (targetId && editedRecordsMap[targetId]) {
      Swal.fire({
        icon: "warning",
        title: translations[lang].frozenAlertTitle,
        text: translations[lang].frozenAlertMsg,
        confirmButtonText: translations[lang].okay || "Okay",
      });
      return;
    }
    if (recordIdToEdit) {
      setRecordId(recordIdToEdit);
      const recordToEdit = allRecords.find((r) => r.id === recordIdToEdit);
      if (recordToEdit) {
        let conditionValue = "";
        if (recordToEdit.sarovar_condition === 1 || recordToEdit.sarovar_condition === "1") {
          conditionValue = "1";
        } else if (recordToEdit.sarovar_condition === 0 || recordToEdit.sarovar_condition === "0") {
          conditionValue = "0";
        } else {
          conditionValue = "";
        }

        setRow({
          hasAmritSarovar: recordToEdit.has_amrit_sarovar === 1 ? "1" : "0",
          condition: conditionValue,
          waterUsage: recordToEdit.water_usage_purpose || "",
          approvedAmount: recordToEdit.sanctioned_amount || "",
          usedAmount: recordToEdit.utilized_amount || "",
          workStatus: recordToEdit.work_status || "",
          remarks: recordToEdit.gram_sabha_remarks || "",
        });
      }
    }
    setIsSubmitted(false);
  };

  /* ---------- DELETE ---------- */
  const handleDelete = async (recordIdToDelete) => {
    const idToDelete = recordIdToDelete || recordId;
    if (idToDelete && editedRecordsMap[idToDelete]) {
      Swal.fire({
        icon: "warning",
        title: translations[lang].frozenAlertTitle,
        text: translations[lang].frozenAlertMsg,
        confirmButtonText: translations[lang].okay || "Okay",
      });
      return;
    }
    if (!idToDelete) return;

    const result = await Swal.fire({
      title: translations[lang].deleteConfirmTitle,
      text: translations[lang].deleteConfirmMsg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: translations[lang].yesDelete,
      cancelButtonText: translations[lang].cancel,
    });

    if (!result.isConfirmed) return;

    try {
      const payload = {
        id: idToDelete,
      };

      await axios.delete("/delete_sarovar_details", {
        data: payload,
        headers: { Authorization: `Bearer ${token}` },
      });

      if (idToDelete) {
        localStorage.removeItem(`sarovar_edited_${idToDelete}`);
        localStorage.removeItem(`sarovar_frozen_${idToDelete}`);
        setEditedRecordsMap((prev) => {
          const next = { ...prev };
          delete next[idToDelete];
          return next;
        });
      }

      if (idToDelete === recordId) {
        setRow({ ...emptyRow });
        setRecordId(null);
        setIsSubmitted(false);
      }

      toast.success("Record deleted successfully");
      await fetchSarovar();
    } catch (err) {
      console.error("Delete Error:", err);
      toast.error("Delete failed: " + (err.response?.data?.message || err.message));
    }
  };

  /* ---------- EXPORT BLANK PDF FORM ---------- */
  const handleExportPDF = () => {
    try {
      const currentDate = new Date().toLocaleDateString("hi-IN");

      const element = document.createElement("div");
      element.innerHTML = `
        <div style="font-family: 'Arial', sans-serif; padding: 20px; max-width: 800px; margin: 0 auto;">
          <div style="text-align: center; margin-bottom: 30px; border-bottom: 2px solid #2E4A8E; padding-bottom: 15px;">
            <h1 style="color: #2E4A8E; margin-bottom: 10px; font-size: 24px;">अमृत सरोवर प्रपत्र</h1>
            <h2 style="color: #333; margin-bottom: 5px; font-size: 18px;">ग्राम सभा अमृत सरोवर रिपोर्ट</h2>
          </div>
          
          <div style="display: flex; justify-content: space-between; margin-bottom: 25px; font-size: 14px;">
            <div>
              <strong>पंचायत:</strong> 
              <span style="border-bottom: 1px dashed #000; min-width: 150px; display: inline-block; margin-left: 10px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            </div>
            <div>
              <strong>तारीख:</strong> ${currentDate}
            </div>
          </div>
          
          <div style="background-color: #f9f9f9; padding: 15px; margin-bottom: 20px; border-left: 3px solid #2E4A8E;">
            <p style="margin: 0; font-style: italic; color: #666; font-size: 13px;">
              नोट: कृपया निम्नलिखित फॉर्म को ध्यान से भरें। सभी जानकारी सही और पूर्ण होनी चाहिए।
            </p>
          </div>
          
          <table style="width: 100%; border-collapse: collapse; margin-bottom: 25px; border: 1px solid #000;">
            <thead>
              <tr style="background-color: #2E4A8E; color: white;">
                <th style="padding: 12px; border: 1px solid #000; text-align: center; width: 5%;">क्र.सं.</th>
                <th style="padding: 12px; border: 1px solid #000; text-align: left; width: 60%;">विवरण</th>
                <th style="padding: 12px; border: 1px solid #000; text-align: center; width: 35%;">मूल्य/उत्तर (भरें)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="padding: 12px; border: 1px solid #000; text-align: center; vertical-align: top;">1.</td>
                <td style="padding: 12px; border: 1px solid #000; vertical-align: top;">
                  क्या इस ग्राम पंचायत में अमृत सरोवर योजना के तहत अमृत सरोवर बनाए गए हैं?
                </td>
                <td style="padding: 12px; border: 1px solid #000; text-align: center; vertical-align: top;">
                  <div style="margin-bottom: 8px;">
                    <span style="margin-right: 15px;">□ हाँ</span>
                    <span>□ नहीं</span>
                  </div>
                </td>
              </tr>
              <tr style="background-color: #f5f5f5;">
                <td style="padding: 12px; border: 1px solid #000; text-align: center; vertical-align: top;">2.</td>
                <td style="padding: 12px; border: 1px solid #000; vertical-align: top;">
                  यदि हां, तो अमृत सरोवर की स्थिति क्या है?
                </td>
                <td style="padding: 12px; border: 1px solid #000; text-align: center; vertical-align: top;">
                  <div style="margin-bottom: 8px;">
                    <span style="margin-right: 15px;">□ अच्छी</span>
                    <span>□ बुरी</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td style="padding: 12px; border: 1px solid #000; text-align: center; vertical-align: top;">3.</td>
                <td style="padding: 12px; border: 1px solid #000; vertical-align: top;">
                  अगर अमृत सरोवर की स्थिति अच्छी है तो इस सरोवर के पानी का उपयोग किस उद्देश्य के लिए किया जा रहा है
                </td>
                <td style="padding: 12px; border: 1px solid #000; text-align: center; vertical-align: top;">
                  <div style="border-bottom: 1px solid #000; display: inline-block; width: 180px; height: 20px;"></div>
                </td>
              </tr>
              <tr style="background-color: #f5f5f5;">
                <td style="padding: 12px; border: 1px solid #000; text-align: center; vertical-align: top;">4.</td>
                <td style="padding: 12px; border: 1px solid #000; vertical-align: top;">
                  अमृत सरोवर के लिए धनराशि स्वीकृत/जारी की गई
                </td>
                <td style="padding: 12px; border: 1px solid #000; text-align: center; vertical-align: top;">
                  ₹ <div style="border-bottom: 1px solid #000; display: inline-block; width: 150px; height: 20px; margin-left: 5px;"></div>
                </td>
              </tr>
              <tr>
                <td style="padding: 12px; border: 1px solid #000; text-align: center; vertical-align: top;">5.</td>
                <td style="padding: 12px; border: 1px solid #000; vertical-align: top;">
                  अमृत सरोवर के लिए उपयोग की गई निधि
                </td>
                <td style="padding: 12px; border: 1px solid #000; text-align: center; vertical-align: top;">
                  ₹ <div style="border-bottom: 1px solid #000; display: inline-block; width: 150px; height: 20px; margin-left: 5px;"></div>
                </td>
              </tr>
              <tr style="background-color: #f5f5f5;">
                <td style="padding: 12px; border: 1px solid #000; text-align: center; vertical-align: top;">6.</td>
                <td style="padding: 12px; border: 1px solid #000; vertical-align: top;">
                  अमृत सरोवर के कार्य की स्थिति
                </td>
                <td style="padding: 12px; border: 1px solid #000; text-align: center; vertical-align: top;">
                  <div style="margin-bottom: 8px;">
                    <div style="margin-bottom: 5px;">□ पूर्ण</div>
                    <div style="margin-bottom: 5px;">□ प्रगति</div>
                    <div>□ शुरू नहीं</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          
          <div style="margin-top: 30px;">
            <div style="font-weight: bold; color: #2E4A8E; margin-bottom: 15px; font-size: 16px;">7. ग्राम सभा के सदस्यों की टिप्पणियां:</div>
            <div style="border-bottom: 1px solid #666; margin: 12px 0; height: 20px;"></div>
            <div style="border-bottom: 1px solid #666; margin: 12px 0; height: 20px;"></div>
            <div style="border-bottom: 1px solid #666; margin: 12px 0; height: 20px;"></div>
            <div style="border-bottom: 1px solid #666; margin: 12px 0; height: 20px;"></div>
            <div style="border-bottom: 1px solid #666; margin: 12px 0; height: 20px;"></div>
            <div style="border-bottom: 1px solid #666; margin: 12px 0; height: 20px;"></div>
          </div>
          
          <div style="display: flex; justify-content: space-between; margin-top: 60px;">
            <div style="width: 45%;">
              <div style="margin-bottom: 5px;">ग्राम सभा प्रतिनिधि</div>
              <div style="border-top: 1px solid #000; padding-top: 5px; text-align: center; font-size: 13px;">हस्ताक्षर</div>
            </div>
            <div style="width: 45%;">
              <div style="margin-bottom: 5px;">पंचायत सचिव</div>
              <div style="border-top: 1px solid #000; padding-top: 5px; text-align: center; font-size: 13px;">हस्ताक्षर</div>
            </div>
          </div>
          
          <div style="text-align: center; margin-top: 50px; font-size: 11px; color: #666; border-top: 1px solid #ddd; padding-top: 15px;">
            <p style="margin: 5px 0;">यह फॉर्म अमृत सरोवर विवरण के लिए है। कृपया भरे हुए फॉर्म को संबंधित कार्यालय में जमा करें।</p>
            <p style="margin: 5px 0;">स्वचालित रूप से जनरेट की गई फॉर्म | ${currentDate}</p>
          </div>
        </div>
      `;

      const opt = {
        margin: [10, 10, 10, 10],
        filename: `अमृत_सरोवर_फॉर्म_${currentDate.replace(/\//g, "-")}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          logging: false,
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
          compress: true,
        },
      };

      html2pdf().set(opt).from(element).save();
      toast.success("PDF फॉर्म डाउनलोड हो रहा है...");
    } catch (error) {
      console.error("PDF export error:", error);
      toast.error("PDF बनाने में त्रुटि");
    }
  };

  return (
    <div style={{ padding: "12px" }}>
      {/* Back Button, PDF Export Button and Language Converter Toggle */}
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Button
          variant="outlined"
          sx={{ color: "#2E4A8E", borderColor: "#2E4A8E" }}
          onClick={() => navigate("/gram-sabha-inspection")}
        >
          {translations[lang].back}
        </Button>

        <Stack direction="row" spacing={2} alignItems="center">
          <Button
            variant="contained"
            color="secondary"
            onClick={handleExportPDF}
            sx={{ backgroundColor: "#4CAF50" }}
          >
            {translations[lang].downloadPdf}
          </Button>

          <Button
            onClick={() => setLang(lang === "en" ? "hi" : "en")}
            variant="outlined"
            style={{ textTransform: "none", color: "#4763E4", borderColor: "#4763E4", fontWeight: "bold" }}
          >
            {translations[lang].langToggle}
          </Button>
        </Stack>
      </Stack>

      <h4 style={{ color: "#2E4A8E", marginBottom: "12px" }}>
        {translations[lang].title}
      </h4>



      {loading ? (
        <div style={{ textAlign: "center", padding: "20px" }}>Loading...</div>
      ) : (
        <>
          <div style={{ overflowX: "auto", width: "100%" }}>
            <Table size="small" sx={{ border: "1px solid #ccc", minWidth: "1200px" }}>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#2E4A8E" }}>
                {[
                  translations[lang].colSrNo,
                  translations[lang].col1,
                  translations[lang].col2,
                  translations[lang].col3,
                  translations[lang].col4,
                  translations[lang].col5,
                  translations[lang].col6,
                  translations[lang].col7,
                  translations[lang].colAction,
                ].map((h, i) => (
                  <TableCell
                    key={i}
                    sx={{
                      color: "#fff",
                      fontSize: "11px",
                      fontWeight: 600,
                      textAlign: "center",
                      border: "1px solid #ccc",
                      minWidth: i === 0 ? "60px" : i === 8 ? "120px" : "200px",
                      maxWidth: i === 0 ? "60px" : i === 8 ? "120px" : "200px",
                      whiteSpace: "normal",
                      wordWrap: "break-word"
                    }}
                  >
                    {h}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {allRecords.length > 0 ? (
                allRecords.map((record, index) => {
                  const isEditing = recordId === record.id && !isSubmitted && !editedRecordsMap[record.id];
                  const recordRow = isEditing
                    ? row
                    : {
                      hasAmritSarovar: record.has_amrit_sarovar === 1 ? "1" : "0",
                      condition: record.sarovar_condition === 1 ? "1" : record.sarovar_condition === 0 ? "0" : "",
                      waterUsage: record.water_usage_purpose || "",
                      approvedAmount: record.sanctioned_amount || "",
                      usedAmount: record.utilized_amount || "",
                      workStatus: record.work_status || "",
                      remarks: record.gram_sabha_remarks || "",
                    };

                  const isRowFrozen = editedRecordsMap[record.id];

                  return (
                    <TableRow key={record.id}>
                      <TableCell align="center">{index + 1}</TableCell>

                      <TableCell>
                        <Select
                          size="small"
                          fullWidth
                          disabled={!isEditing || isRowFrozen}
                          value={recordRow.hasAmritSarovar}
                          onChange={(e) => handleChange("hasAmritSarovar", e.target.value)}
                        >
                          <MenuItem value="0">{translations[lang].no}</MenuItem>
                          <MenuItem value="1">{translations[lang].yes}</MenuItem>
                        </Select>
                      </TableCell>

                      <TableCell>
                        {isEditing ? (
                          <FormControl size="small" fullWidth>
                            <Select
                              variant="outlined"
                              displayEmpty
                              disabled={recordRow.hasAmritSarovar === "0" || isRowFrozen}
                              value={recordRow.condition || ""}
                              onChange={(e) => handleChange("condition", e.target.value)}
                            >
                              <MenuItem value="">{translations[lang].select}</MenuItem>
                              <MenuItem value="1">{translations[lang].good}</MenuItem>
                              <MenuItem value="0">{translations[lang].bad}</MenuItem>
                            </Select>
                          </FormControl>
                        ) : (
                          <FormControl size="small" fullWidth>
                            <Select
                              variant="outlined"
                              value={
                                record.sarovar_condition === 1 || record.sarovar_condition === "1"
                                  ? "1"
                                  : record.sarovar_condition === 0 || record.sarovar_condition === "0"
                                    ? "0"
                                    : ""
                              }
                              disabled
                              displayEmpty
                            >
                              <MenuItem value="">{translations[lang].select}</MenuItem>
                              <MenuItem value="1">{translations[lang].good}</MenuItem>
                              <MenuItem value="0">{translations[lang].bad}</MenuItem>
                            </Select>
                          </FormControl>
                        )}
                      </TableCell>

                      <TableCell>
                        <Tooltip 
                          title={recordRow.waterUsage || ""} 
                          arrow 
                          placement="bottom" 
                          disableHoverListener={!recordRow.waterUsage}
                          componentsProps={{
                            tooltip: { sx: { backgroundColor: '#ffffff !important', color: '#000000 !important', border: '1px solid #ccc', boxShadow: '0px 2px 4px rgba(0,0,0,0.1)', fontSize: '13px' } },
                            arrow: { sx: { color: '#ffffff !important' } }
                          }}
                        >
                          <TextField
                            size="small"
                            fullWidth
                            disabled={!isEditing || recordRow.hasAmritSarovar === "0" || recordRow.condition !== "1" || isRowFrozen}
                            value={recordRow.waterUsage}
                            onChange={(e) => handleChange("waterUsage", e.target.value)}
                            placeholder={translations[lang].placeholderUsage}
                          />
                        </Tooltip>
                      </TableCell>

                      <TableCell>
                        <TextField
                          size="small"
                          type="number"
                          fullWidth
                          disabled={!isEditing || recordRow.hasAmritSarovar === "0" || isRowFrozen}
                          value={recordRow.approvedAmount}
                          onChange={(e) => handleChange("approvedAmount", e.target.value)}
                          placeholder={translations[lang].placeholderAmount}
                        />
                      </TableCell>

                      <TableCell>
                        <TextField
                          size="small"
                          type="number"
                          fullWidth
                          disabled={!isEditing || recordRow.hasAmritSarovar === "0" || isRowFrozen}
                          value={recordRow.usedAmount}
                          onChange={(e) => handleChange("usedAmount", e.target.value)}
                          placeholder={translations[lang].placeholderAmount}
                        />
                      </TableCell>

                      <TableCell>
                        <Select
                          size="small"
                          fullWidth
                          disabled={!isEditing || recordRow.hasAmritSarovar === "0" || isRowFrozen}
                          value={recordRow.workStatus}
                          onChange={(e) => handleChange("workStatus", e.target.value)}
                        >
                          <MenuItem value="">{translations[lang].select}</MenuItem>
                          <MenuItem value="पूर्ण">{translations[lang].completed}</MenuItem>
                          <MenuItem value="प्रगति">{translations[lang].inProgress}</MenuItem>
                          <MenuItem value="शुरू नहीं">{translations[lang].notStarted}</MenuItem>
                        </Select>
                      </TableCell>

                      <TableCell>
                        <Tooltip 
                          title={recordRow.remarks || ""} 
                          arrow 
                          placement="bottom" 
                          disableHoverListener={!recordRow.remarks}
                          componentsProps={{
                            tooltip: { sx: { backgroundColor: '#ffffff !important', color: '#000000 !important', border: '1px solid #ccc', boxShadow: '0px 2px 4px rgba(0,0,0,0.1)', fontSize: '13px' } },
                            arrow: { sx: { color: '#ffffff !important' } }
                          }}
                        >
                          <TextField
                            size="small"
                            fullWidth
                            disabled={!isEditing || isRowFrozen}
                            value={recordRow.remarks}
                            onChange={(e) => handleChange("remarks", e.target.value)}
                            placeholder={translations[lang].placeholderRemarks}
                          />
                        </Tooltip>
                      </TableCell>

                      <TableCell align="center">
                        <Stack direction="row" spacing={1} justifyContent="center">
                          <Tooltip
                            title={
                              isRowFrozen
                                ? translations[lang].frozenTooltip
                                : ""
                            }
                            arrow
                          >
                            <span>
                              <Button
                                size="small"
                                variant="outlined"
                                onClick={() => handleEdit(record.id)}
                                disabled={!hasRecords || isEditing || isRowFrozen}
                              >
                                {isRowFrozen ? translations[lang].frozen : translations[lang].edit}
                              </Button>
                            </span>
                          </Tooltip>
                          <Button
                            size="small"
                            variant="outlined"
                            color="error"
                            onClick={() => handleDelete(record.id)}
                            disabled={!hasRecords || isRowFrozen}
                          >
                            {translations[lang].delete}
                          </Button>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell align="center">1</TableCell>

                  <TableCell>
                    <Select
                      size="small"
                      fullWidth
                      disabled={isSubmitted}
                      value={row.hasAmritSarovar}
                      onChange={(e) => handleChange("hasAmritSarovar", e.target.value)}
                    >
                      <MenuItem value="0">{translations[lang].no}</MenuItem>
                      <MenuItem value="1">{translations[lang].yes}</MenuItem>
                    </Select>
                  </TableCell>

                  <TableCell>
                    <FormControl size="small" fullWidth>
                      <Select
                        variant="outlined"
                        displayEmpty
                        disabled={isSubmitted || row.hasAmritSarovar === "0"}
                        value={row.condition || ""}
                        onChange={(e) => handleChange("condition", e.target.value)}
                      >
                        <MenuItem value="">{translations[lang].select}</MenuItem>
                        <MenuItem value="1">{translations[lang].good}</MenuItem>
                        <MenuItem value="0">{translations[lang].bad}</MenuItem>
                      </Select>
                    </FormControl>
                  </TableCell>

                  <TableCell>
                    <Tooltip 
                      title={row.waterUsage || ""} 
                      arrow 
                      placement="bottom" 
                      disableHoverListener={!row.waterUsage}
                      componentsProps={{
                        tooltip: { sx: { backgroundColor: '#ffffff !important', color: '#000000 !important', border: '1px solid #ccc', boxShadow: '0px 2px 4px rgba(0,0,0,0.1)', fontSize: '13px' } },
                        arrow: { sx: { color: '#ffffff !important' } }
                      }}
                    >
                      <TextField
                        size="small"
                        fullWidth
                        disabled={isSubmitted || row.hasAmritSarovar === "0" || row.condition !== "1"}
                        value={row.waterUsage}
                        onChange={(e) => handleChange("waterUsage", e.target.value)}
                        placeholder={translations[lang].placeholderUsage}
                      />
                    </Tooltip>
                  </TableCell>

                  <TableCell>
                    <TextField
                      size="small"
                      type="number"
                      fullWidth
                      disabled={isSubmitted || row.hasAmritSarovar === "0"}
                      value={row.approvedAmount}
                      onChange={(e) => handleChange("approvedAmount", e.target.value)}
                      placeholder={translations[lang].placeholderAmount}
                    />
                  </TableCell>

                  <TableCell>
                    <TextField
                      size="small"
                      type="number"
                      fullWidth
                      disabled={isSubmitted || row.hasAmritSarovar === "0"}
                      value={row.usedAmount}
                      onChange={(e) => handleChange("usedAmount", e.target.value)}
                      placeholder={translations[lang].placeholderAmount}
                    />
                  </TableCell>

                  <TableCell>
                    <Select
                      size="small"
                      fullWidth
                      disabled={isSubmitted || row.hasAmritSarovar === "0"}
                      value={row.workStatus}
                      onChange={(e) => handleChange("workStatus", e.target.value)}
                    >
                      <MenuItem value="">{translations[lang].select}</MenuItem>
                      <MenuItem value="पूर्ण">{translations[lang].completed}</MenuItem>
                      <MenuItem value="प्रगति">{translations[lang].inProgress}</MenuItem>
                      <MenuItem value="शुरू नहीं">{translations[lang].notStarted}</MenuItem>
                    </Select>
                  </TableCell>

                  <TableCell>
                    <Tooltip 
                      title={row.remarks || ""} 
                      arrow 
                      placement="bottom" 
                      disableHoverListener={!row.remarks}
                      componentsProps={{
                        tooltip: { sx: { backgroundColor: '#ffffff !important', color: '#000000 !important', border: '1px solid #ccc', boxShadow: '0px 2px 4px rgba(0,0,0,0.1)', fontSize: '13px' } },
                        arrow: { sx: { color: '#ffffff !important' } }
                      }}
                    >
                      <TextField
                        size="small"
                        fullWidth
                        disabled={isSubmitted}
                        value={row.remarks}
                        onChange={(e) => handleChange("remarks", e.target.value)}
                        placeholder={translations[lang].placeholderRemarks}
                      />
                    </Tooltip>
                  </TableCell>

                  <TableCell align="center">
                    {!["1", "3", "7", "8"].includes(sessionStorage.getItem("role_id")) && (
                      <Stack direction="row" spacing={1} justifyContent="center">
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => handleEdit(recordId)}
                          disabled={!hasRecords || !isSubmitted || (recordId && editedRecordsMap[recordId])}
                        >
                          {recordId && editedRecordsMap[recordId] ? translations[lang].frozen : translations[lang].edit}
                        </Button>
                        <Button
                          size="small"
                          variant="outlined"
                          color="error"
                          onClick={() => handleDelete(recordId)}
                          disabled={!hasRecords || !recordId || (recordId && editedRecordsMap[recordId])}
                        >
                          {translations[lang].delete}
                        </Button>
                      </Stack>
                    )}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>

          {!["1", "3", "7", "8"].includes(sessionStorage.getItem("role_id")) && (
            <div style={{ marginTop: "16px", display: "flex", gap: "10px" }}>
              {!isSubmitted && !recordId ? (
                <Button variant="contained" color="success" onClick={handleSaveClick}>
                  {translations[lang].submit}
                </Button>
              ) : !isSubmitted && recordId ? (
                <>
                  <Button variant="contained" color="primary" onClick={handleUpdateClick}>
                    {translations[lang].update}
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={async () => {
                      setIsSubmitted(true);
                      await fetchSarovar();
                    }}
                  >
                    {translations[lang].cancel}
                  </Button>
                </>
              ) : null}
            </div>
          )}
        </>
      )}

      {/* Confirmation Dialog Popup */}
      <Dialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        aria-labelledby="confirm-sarovar-dialog-title"
        aria-describedby="confirm-sarovar-dialog-description"
      >
        <DialogTitle
          id="confirm-sarovar-dialog-title"
          style={{ fontWeight: "bold", color: "#2E4A8E" }}
        >
          {confirmType === "save" ? translations[lang].confirmSaveTitle : translations[lang].confirmUpdateTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="confirm-sarovar-dialog-description"
            style={{ color: "#333", fontSize: "15px" }}
          >
            {confirmType === "save"
              ? translations[lang].confirmSaveMsg
              : translations[lang].confirmUpdateMsg}
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ padding: "15px 24px" }}>
          <Button
            onClick={() => setOpenConfirmDialog(false)}
            variant="outlined"
            style={{
              textTransform: "none",
              color: "#666",
              borderColor: "#ccc",
            }}
          >
            {translations[lang].cancel}
          </Button>
          <Button
            onClick={confirmType === "save" ? executeSave : executeUpdate}
            variant="contained"
            color="primary"
            autoFocus
            style={{ textTransform: "none", backgroundColor: "#2E4A8E" }}
          >
            {confirmType === "save" ? translations[lang].yesSave : translations[lang].yesUpdate}
          </Button>
        </DialogActions>
      </Dialog>

      <ToastContainer />
    </div>
  );
};

export default AmritSarovar;